/* File serves the mentorpick logo icon */

import React from 'react'
import MentorpickLogo from '../../../assets/mentorpick.jpeg'

const MentorpickIcon = () => {
  return (
    <img src={MentorpickLogo} alt="Mentorpick" style={{height: '25px', width: '24px', filter : 'sepia(100%) hue-rotate(180deg) saturate(200%) brightness(150%)'}}/>
  )
}

export default MentorpickIcon